/** @jsx jsx */
import { Fragment, useEffect, useState } from 'react';
import { jsx } from '@balance-web/core';
import { Flex } from '@balance-web/flex';
import { ProductMenuController } from '@balance-web/product-menu';

import { AppList } from './AppList';
import { SwitcherIcon } from './SwitcherIcon';
import { ItemWrapper } from './ItemWrapper';
import type { Apps } from './types';
import { createTestId } from './utils';
import { appSwitcherEventEmitter } from './appSwitcherEvents';

export type AppSwitcherProps = {
  apps: Apps;
  isLoading?: boolean;
  onEmptyStatePrimaryActionClick: () => void;
};
export const AppSwitcher = ({
  apps,
  isLoading,
  onEmptyStatePrimaryActionClick,
}: AppSwitcherProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    return appSwitcherEventEmitter.subscribe('onClose', () => {
      setIsOpen(false);
    });
  }, []);

  return (
    <Fragment>
      <Flex alignItems="center">
        <ItemWrapper
          as="button"
          data={{ testid: createTestId('app-switcher-trigger') }}
          onClick={() => {
            return setIsOpen(true);
          }}
        >
          <div css={{ lineHeight: 0 }}>
            <SwitcherIcon />
          </div>
        </ItemWrapper>
      </Flex>
      <ProductMenuController
        isOpen={isOpen}
        onClose={() => {
          return setIsOpen(false);
        }}
      >
        <AppList
          apps={apps}
          isLoading={isLoading}
          onClose={() => {
            return setIsOpen(false);
          }}
          onEmptyStatePrimaryActionClick={onEmptyStatePrimaryActionClick}
        />
      </ProductMenuController>
    </Fragment>
  );
};

export const closeAppSwitcher = () => {
  appSwitcherEventEmitter.broadcast('onClose', []);
};
